import { gql } from '@apollo/client';

export const GET_RECOMMENDED_USERS_FOR_PROJECT = gql`
  query GetRecommendedUsersForProject($projectId: Int!, $topN: Int) {
    getRecommendedUsersForProject(projectId: $projectId, topN: $topN) {
      projectId
      userIds
      similarityScores
    }
  }
`;